/**
 * Created by andrey on 04.11.2025
 */

const IslandDecorationComponent = function (unit, options) {
    UnitComponent.call(this, unit);

    this.mission = options.mission;
    this.logic = this.mission && this.mission.logic;
    const period = this.logic ? this.logic.period : "stub";
    this.bundle = IslandDecorationHelper.getItemsBundle(period);

    cleverapps.bundleLoader.loadBundle(this.bundle.name);
};

IslandDecorationComponent.prototype = Object.create(UnitComponent.prototype);
IslandDecorationComponent.prototype.constructor = IslandDecorationComponent;

IslandDecorationComponent.prototype.destructor = function () {
    cleverapps.bundleLoader.deleteBundle(this.bundle.name);
};

IslandDecorationComponent.prototype.handleClick = function () {
    if (!this.mission) {
        cleverapps.centerHint.createTextHint(Messages.get("IslandDecoration.StubHint"));
        return;
    }

    const mission = this.mission;

    cleverapps.focusManager.display({
        focus: "IslandDecorationClicked",
        action: function (f) {
            if (!mission.isRunning() && (!mission.tillTheTimeEnds || mission.getTimeLeft() === 0)) {
                mission.displayCompleted(f);
                return;
            }

            const ViewClass = mission.getViewClass();
            new ViewClass(mission);

            mission.skipStartWindow();

            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });
};

IslandDecorationComponent.prototype.checkTouchInside = function (touch) {
    if (this.view) {
        return this.view.checkTouchInside(touch);
    }
};

IslandDecorationComponent.prototype.onDestruction = function () {
    if (this.view) {
        this.view.onDestruction();
    }
};

IslandDecorationComponent.prototype.spawn = function () {
    const pos = Map2d.currentMap.regions.islanddecoration.positions[0];
    this.unit.setPosition(pos.x, pos.y);

    Map2d.currentMap.add(Map2d.LAYER_UNITS, this.unit.x, this.unit.y, this.unit);
    Map2d.currentMap.onAddUnit(this.unit.x, this.unit.y, this.unit);
};

IslandDecorationComponent.prototype.remove = function () {
    this.onDestruction();
    this.unit.remove(true);
};